{
  "You're invited to watch {title}": "Du bist eingeladen, {title} anzusehen",
  "Share your event link": "Teile deinen Event-Link",
  "device|desktop": "Computer",
  "device|phone": "Smartphone",
  "device|tablet": "Tablet",
  "device|tv": "Fernseher",
  "device|console": "Konsole",
  "{hours}h {minutes}m": "{hours} Std. {minutes} Min.",
  "Sorry, there's been an error loading the analytics data.": "Beim Laden der Statistiken ist leider ein Fehler aufgetreten.",
  "Detailed analytics are available for events starting May 20, 2025. Below are the basic statistics for this event.": "Detaillierte Statistiken gibt es für Events ab dem 20. Mai 2025. Unten siehst du die grundlegenden Zahlen zu diesem Event.",
  "Viewed Live": "Live zugesehen",
  "Watched Replay": "Aufzeichnung angesehen",
  "Powered by": "Bereitgestellt von",
  "{count} views": {
    "one": "{count} Aufruf",
    "other": "{count} Aufrufe"
  },
  "{count} viewers": {
    "one": "{count} Zuschauer",
    "other": "{count} Zuschauer"
  },
  "Total Views": "Aufrufe gesamt",
  "Unique Viewers": "Eindeutige Zuschauer",
  "Total Watch Time": "Wiedergabezeit gesamt",
  "Views": "Aufrufe",
  "Watch Time": "Wiedergabezeit",
  "Top Countries": "Top-Länder",
  "Top Regions / States": "Top-Regionen / Bundesstaaten",
  "analytics|Unknown": "Unbekannt",
  "Device Categories": "Gerätetypen",
  "Operating Systems": "Betriebssysteme",
  "Import": "Importieren",
  "Invite a guest": "Gast einladen",
  "We'll email them the event link and remind them before you go live.": "Wir schicken den Event-Link per E-Mail und senden eine Erinnerung, bevor du live gehst.",
  "CSV Import": "CSV-Import",
  "Select File": "Datei auswählen",
  "Format: CSV. Required column: Email. Optional columns: Name, First Name, Last Name": "Format: CSV. Pflichtspalte: „Email“. Optionale Spalten: „Name“, „First Name“, „Last Name“ (auf Englisch)",
  "Invite All ({count})": "Alle einladen ({count})",
  "Couldn't load the guest list": "Die Gästeliste konnte nicht geladen werden",
  "Remove the guest from the list?": "Gast von der Liste entfernen?",
  "guest status|Joined Live": "Live zugesehen",
  "guest status|Watched Replay": "Aufzeichnung angesehen",
  "guest status|Visited page": "Seite besucht",
  "guest status|Invited": "Eingeladen",
  "{count} guest": {
    "one": "{count} Gast",
    "other": "{count} Gäste"
  },
  "Open the guest list": "Gästeliste öffnen",
  "Guests of every {noun} are on the guest list of {label} (the main link). They sign up once and can watch every {noun}.": "Gäste stehen nicht pro {noun}, sondern gemeinsam auf der Gästeliste von {label} (dem Hauptlink). Sie registrieren sich einmal und können alle Streams ansehen.",
  "Start inviting guests": "Lade deine Gäste ein",
  "Invite guests by email or just share your event link with them.": "Lade Gäste per E-Mail ein oder teile einfach deinen Event-Link mit ihnen.",
  "Guests who sign the guestbook or ask for reminders appear here too.": "Gäste, die ins Gästebuch schreiben oder sich erinnern lassen, erscheinen auch hier.",
  "Share link": "Link teilen",
  "Download guest list": "Gästeliste herunterladen",
  "Guests {title}.csv": "Gäste {title}.csv",
  "Guests.csv": "Gäste.csv",
  "{title}-report.pdf": "{title}-Bericht.pdf",
  "analytics-report.pdf": "statistikbericht.pdf",
  "Export PDF": "PDF exportieren",
  "Invitation sent": "Einladung gesendet",
  "{name} will get reminders before you go live.": "{name} bekommt Erinnerungen, bevor du live gehst.",
  "Couldn't send the invitation": "Die Einladung konnte nicht gesendet werden",
  "Guest's name": "Name des Gastes",
  "e.g. Maria Lopez": "z. B. Maria Schmidt",
  "Send invitation": "Einladung senden",
  "Could not open image library.": "Die Fotomediathek konnte nicht geöffnet werden.",
  "Delete Cover?": "Titelbild löschen?",
  "Delete failed": "Löschen fehlgeschlagen",
  "Processing image...": "Bild wird verarbeitet...",
  "Uploading... {percent}%": "Wird hochgeladen... {percent} %",
  "Invalid file": "Ungültige Datei",
  "Only JPG or PNG files are accepted": "Nur JPG- oder PNG-Dateien sind erlaubt",
  "Drop image here": "Bild hier ablegen",
  "Drop image here or click to select": "Bild hier ablegen oder zum Auswählen klicken",
  "Recommended size: 1280x720 pixels": "Empfohlene Größe: 1280x720 Pixel",
  "Accepts PNG or JPG under 50MB": "PNG oder JPG bis 50 MB",
  "Couldn't save that": "Das konnte nicht gespeichert werden",
  "Guests who watch on your website get emails that link back to the page they watched on.": "Gäste, die auf deiner Website zusehen, bekommen E-Mails mit Links zurück zu der Seite, auf der sie zugesehen haben.",
  "Pages where guests watch your embed will show up here.": "Hier erscheinen die Seiten, auf denen Gäste dein Embed ansehen.",
  "Seen on": "Gesehen auf",
  "Use for email links": "Für E-Mail-Links verwenden",
  "Ignore": "Ignorieren",
  "Used for email links": "Wird für E-Mail-Links verwendet",
  "Stop using": "Nicht mehr verwenden",
  "Other guests": "Andere Gäste",
  "Your Embed webpage URL from before. Remove it to send everyone else to evt.live.": "Die URL deiner Embed-Webseite von früher. Entferne sie, um alle anderen zu evt.live zu leiten.",
  "EventLive event": "EventLive-Event",
  "How this event's page looks to guests. It overrides the branding in your profile.": "So sehen Gäste die Seite dieses Events. Das hat Vorrang vor dem Branding in deinem Profil.",
  "Could not update branding settings": "Die Branding-Einstellungen konnten nicht aktualisiert werden",
  "Event page": "Eventseite",
  "Description": "Beschreibung",
  "A few words for your guests": "Ein paar Worte für deine Gäste",
  "Supports Markdown: **bold**, lists and links.": "Unterstützt Markdown: **fett**, Listen und Links.",
  "e.g. 7pm ET / 4pm PT": "z. B. 19 Uhr Berlin / 18 Uhr London",
  "Replaces the date and time on your event page and in reminder emails.": "Ersetzt Datum und Uhrzeit auf deiner Eventseite und in Erinnerungs-E-Mails.",
  "Company": "Unternehmen",
  "Shown on this event page only. PNG or JPG; it's trimmed and resized automatically. Horizontal logos work best. A white logo on a transparent background may not show on a light page.": "Wird nur auf dieser Eventseite angezeigt. PNG oder JPG; wird automatisch zugeschnitten und skaliert. Logos im Querformat wirken am besten. Ein weißes Logo auf transparentem Hintergrund ist auf einer hellen Seite eventuell nicht zu sehen.",
  "Put your event page or just the video player on your own website.": "Bau deine Eventseite oder nur den Videoplayer in deine eigene Website ein.",
  "Layout": "Layout",
  "Full embed": "Komplettes Embed",
  "The event page: video, guestbook and reminders.": "Die Eventseite: Video, Gästebuch und Erinnerungen.",
  "Just video": "Nur Video",
  "Only the video player.": "Nur der Videoplayer.",
  "These change the code below. Copy it again after changing them.": "Diese Optionen ändern den Code unten. Kopiere ihn nach jeder Änderung erneut.",
  "Autoplay": "Automatische Wiedergabe",
  "Start the video automatically.": "Startet das Video automatisch.",
  "Reminder button": "Erinnerungs-Button",
  "Guests can sign up for reminders from your website.": "Gäste können sich auf deiner Website für Erinnerungen anmelden.",
  "No replay and no rewind in the embed.": "Keine Aufzeichnung und kein Zurückspulen im Embed.",
  "Script (recommended)": "Skript (empfohlen)",
  "Viewers who open an EventLive email link on your page are recognized there, and the player is sized to fit.": "Zuschauer, die auf deiner Seite einen Link aus einer EventLive-E-Mail öffnen, werden dort erkannt, und der Player passt seine Größe an.",
  "Simple iframe (no script)": "Einfaches iframe (ohne Skript)",
  "For site builders that remove scripts. The player can't see viewers' email links, so ticket holders on a new device may have to sign in again.": "Für Website-Baukästen, die Skripte entfernen. Der Player erkennt die E-Mail-Links der Zuschauer nicht, daher müssen sich Ticketinhaber auf einem neuen Gerät eventuell erneut anmelden.",
  "Embed code": "Embed-Code",
  "Copy embed code": "Embed-Code kopieren",
  "Embed code copied": "Embed-Code kopiert",
  "Paste it into your website's HTML.": "Füge ihn in das HTML deiner Website ein.",
  "Preview": "Vorschau",
  "Couldn't load the guestbook": "Das Gästebuch konnte nicht geladen werden",
  "Delete this message?": "Diese Nachricht löschen?",
  "Messaging": "Nachrichten",
  "Chat": "Chat",
  "You pinned": "Von dir angeheftet",
  "Delete this message": "Diese Nachricht löschen",
  "Could not update messaging settings": "Die Nachrichteneinstellungen konnten nicht aktualisiert werden",
  "Guests sign it and add photos. Newest messages first.": "Gäste schreiben hinein und fügen Fotos hinzu. Neueste Nachrichten zuerst.",
  "A live chat next to the video, like a group conversation.": "Ein Live-Chat neben dem Video, wie ein Gruppenchat.",
  "Disable messaging": "Nachrichten deaktivieren",
  "Guests can watch but can't post messages.": "Gäste können zusehen, aber keine Nachrichten schreiben.",
  "{count} message": {
    "one": "{count} Nachricht",
    "other": "{count} Nachrichten"
  },
  "Loading messages…": "Nachrichten werden geladen…",
  "No messages yet. They'll appear here as guests post them.": "Noch keine Nachrichten. Sie erscheinen hier, sobald Gäste etwas schreiben.",
  "Could not update privacy settings": "Die Privatsphäre-Einstellungen konnten nicht aktualisiert werden",
  "Hide event page": "Eventseite verbergen",
  "Manage tickets": "Tickets verwalten",
  "Guests need a ticket to watch. To let some guests in for free, invite them from the Guest List.": "Gäste brauchen ein Ticket, um zuzusehen. Um einzelne Gäste kostenlos zusehen zu lassen, lade sie über die Gästeliste ein.",
  "Anyone with the link can watch": "Jeder mit dem Link kann zusehen",
  "Share the link; no password or invitation needed.": "Teile den Link; kein Passwort und keine Einladung nötig.",
  "Password protected": "Passwortgeschützt",
  "Guests enter a password you give them.": "Gäste geben ein Passwort ein, das du ihnen gibst.",
  "Choose a password": "Wähle ein Passwort",
  "Invite only": "Nur mit Einladung",
  "Only the guests invited by email can join. One device per email at a time. (MUST be on the <list>Guest List</list>)": "Nur per E-Mail eingeladene Gäste können teilnehmen. Ein Gerät pro E-Mail-Adresse gleichzeitig. (MÜSSEN auf der <list>Gästeliste</list> stehen)",
  "Ask guests for their name and email": "Gäste nach Name und E-Mail-Adresse fragen",
  "Always on for invite-only events.": "Bei Events nur mit Einladung immer aktiv.",
  "Before they can watch. They'll appear in your Guest List.": "Bevor sie zusehen können. Sie erscheinen in deiner Gästeliste.",
  "Replay and download": "Aufzeichnung und Download",
  "Show download link to guests": "Gästen den Download-Link anzeigen",
  "Hide viewer counter": "Zuschauerzähler ausblenden",
  "Your event page is hidden. People who bought tickets can't watch until you show it again.": "Deine Eventseite ist verborgen. Wer ein Ticket gekauft hat, kann erst wieder zusehen, wenn du sie wieder anzeigst.",
  "Your event page is hidden. Guests can't open it until you show it again.": "Deine Eventseite ist verborgen. Gäste können sie erst wieder öffnen, wenn du sie wieder anzeigst.",
  "Show event page": "Eventseite anzeigen",
  "Remove {guest} from the guest list": "{guest} von der Gästeliste entfernen",
  "Message pinned": "Nachricht angeheftet",
  "Guests see it at the top of the guestbook.": "Gäste sehen sie oben im Gästebuch.",
  "Couldn't pin the message": "Die Nachricht konnte nicht angeheftet werden",
  "e.g. Welcome! The ceremony starts at 3 pm.": "z. B. Willkommen! Die Zeremonie beginnt um 15 Uhr.",
  "Stays at the top of the guestbook or chat.": "Bleibt oben im Gästebuch oder Chat.",
  "Pin message": "Nachricht anheften",
  "Share on {network}": "Auf {network} teilen",
  "Share on Email": "Per E-Mail teilen",
  "Preview my Event Page": "Vorschau meiner Eventseite",
  "Share via:": "Teilen über:",
  "Viewer-hours": "Zuschauerstunden",
  "{count} viewer-hour": {
    "one": "{count} Zuschauerstunde",
    "other": "{count} Zuschauerstunden"
  },
  "Live {live} · Replay {replay}": "Live {live} · Aufzeichnung {replay}",
  "Ticketed events have no viewer-hour limit.": "Events mit Tickets haben kein Limit für Zuschauerstunden.",
  "{used} of {limit} viewer-hours included with this event": "{used} von {limit} Zuschauerstunden, die in diesem Event enthalten sind",
  "Over the {limit} viewer-hours included with this event by {over}.": "{over} über den {limit} Zuschauerstunden, die in diesem Event enthalten sind.",
  "By day (UTC)": "Pro Tag (UTC)",
  "Show fewer days": "Weniger Tage anzeigen",
  "Show all {count} days": {
    "one": "{count} Tag anzeigen",
    "other": "Alle {count} Tage anzeigen"
  },
  "Viewer-hours are updated every hour. They show here within an hour of people watching.": "Zuschauerstunden werden stündlich aktualisiert. Sie erscheinen hier innerhalb einer Stunde, nachdem jemand zugesehen hat.",
  "Live viewers": "Live-Zuschauer",
  "Devices watching each minute of the live stream.": "Geräte, die in der jeweiligen Minute des Livestreams zugesehen haben.",
  "Live viewers per minute from {start} to {end}. Peak: {peak} at {time}.": "Live-Zuschauer pro Minute von {start} bis {end}. Höchstwert: {peak} um {time}.",
  "Peak: {count} at {time}": "Höchstwert: {count} um {time}",
  "{count} viewer at {time}": {
    "one": "{count} Zuschauer um {time}",
    "other": "{count} Zuschauer um {time}"
  },
  "Browsers and apps": "Browser und Apps",
  "{count} viewer": {
    "one": "{count} Zuschauer",
    "other": "{count} Zuschauer"
  },
  "Regions:": "Regionen:",
  "IP Geolocation by DB-IP": "IP-Geolokalisierung von DB-IP",
  "Before {date}": "Vor dem {date}",
  "From our previous analytics, which counted browsers only, saved for good before they expired.": "Aus unseren früheren Statistiken, die nur Browser gezählt haben – dauerhaft gesichert, bevor sie abgelaufen wären.",
  "Viewers": "Zuschauer",
  "{live} live · {replay} replay only": "{live} live · {replay} nur Aufzeichnung",
  "{time} per viewer": "{time} pro Zuschauer",
  "Peak live viewers": "Höchstzahl Live-Zuschauer",
  "Watch time, views, countries and devices are counted from {date}. Unique viewers are counted for every event.": "Wiedergabezeit, Aufrufe, Länder und Geräte werden ab dem {date} gezählt. Eindeutige Zuschauer werden für jedes Event gezählt.",
  "Viewers here are devices on each day: someone watching on two days counts twice. Counted every hour from the video our CDN delivered, on every player.": "Zuschauer sind hier Geräte pro Tag: Wer an zwei Tagen zusieht, zählt doppelt. Stündlich gezählt anhand des Videos, das unser CDN ausgeliefert hat, auf jedem Player.",
  "Each viewer counts once, however many days they watch. Counted every hour from the video our CDN delivered, on every player.": "Jeder Zuschauer zählt einmal, egal an wie vielen Tagen er zusieht. Stündlich gezählt anhand des Videos, das unser CDN ausgeliefert hat, auf jedem Player.",
  "analytics|Other": "Sonstige",
  "Analytics are updated every hour. They show here within an hour of people watching.": "Statistiken werden stündlich aktualisiert. Sie erscheinen hier innerhalb einer Stunde, nachdem jemand zugesehen hat.",
  "Counted from {date}; the viewing before it is further down.": "Gezählt ab dem {date}; was davor angesehen wurde, steht weiter unten.",
  "Counted from {date}; the viewing before it wasn't counted.": "Gezählt ab dem {date}; was davor angesehen wurde, ist nicht erfasst.",
  "Live viewing during {times} isn't fully counted: our video network didn't save all its logs for that time.": "Was während {times} live angesehen wurde, ist nicht vollständig erfasst: Unser Videonetzwerk hat für diesen Zeitraum nicht alle Logs gespeichert.",
  "Updated hourly.": "Stündlich aktualisiert.",
  "Last updated {date}, {time}": "Zuletzt aktualisiert: {date}, {time}",
  "analytics|Live": "Live",
  "analytics|Replay": "Aufzeichnung"
}
